import styled, { keyframes } from 'styled-components'

const animateGlow = keyframes`
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
`
export const TeamNataContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1170px;
  gap: 80px;
  padding: 0 16px;

  .title {
    max-width: 700px;
    strong {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .logo-form {
    display: flex;
    gap: 104px;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    position: relative;

    img {
      width: 291px;
      height: 331px;
    }

    &::before {
      content: '';
      display: block;
      z-index: -1;

      position: absolute;
      bottom: 15%;
      left: 5%;

      width: 220px;
      height: 220px;

      animation: ${animateGlow} 7s ease-in-out infinite;
      background: linear-gradient(270deg, #08eddc, #09a8fa);
      background-size: 200% 200%;

      will-change: transform; // pre-optimizes for the blur filter
      filter: blur(166px);
    }
  }

  @media (max-width: 791px) {
    .title {
      font-size: 20px;
      line-height: 30px;
    }

    .logo-form {
      flex-direction: column-reverse;
      gap: 80px;
      img {
        width: 159px;
        height: 181px;
      }
      &::before {
        left: auto;
        bottom: 0;
        width: 180px;
        height: 180px;
      }
    }
  }
`
